import React, { useState, createContext } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [loggedInId, setLoggedInId] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const value = {
    currentUser,
    setCurrentUser,
    loggedInId,
    setLoggedInId,
    isSuperAdmin,
    setIsSuperAdmin,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
